import pako from "pako";
import { networkService } from "../components/config/axios";
import noImage from "../../assets/images/icon_upload.svg";
import { keepProportions } from "../hooks/utils";

export const compress = (obj) => {
  const jsonString = JSON.stringify(obj);
  const compressed = pako.deflate(jsonString, { to: "string" });
  return btoa(compressed);
};

export const decompress = (str) => {
  const compressed = atob(str);
  const jsonString = pako.inflate(compressed, { to: "string" });
  return JSON.parse(jsonString);
};

export const setReceiverCookie = function (cookieKey, cookieValue) {
  var receiverCookie = getCookie("receiver", {});
  receiverCookie[cookieKey] = cookieValue;
  setCookie("receiver", receiverCookie);
};

export const setReceiverSession = async function (id, tlId, sessionId) {
  const url = `/assign-session/${id}/${tlId}/${sessionId}.json`;
  const response = await networkService(url, "GET");
  return response.data;
};

export const getCookie = function (storageKey, returnedValue) {
  var storageValue = localStorage.getItem(storageKey);
  if (storageValue === null || storageValue === undefined) {
    storageValue = returnedValue;
  } else {
    storageValue = JSON.parse(storageValue);
  }

  return storageValue;
};

export const setCookie = function (storageKey, storageValue) {
  var compressedValue = JSON.stringify(storageValue);
  localStorage.setItem(storageKey, compressedValue);
};

export const dispatchEvent = (name, id) => {
  const event = new Event(name);
  const emitter = document.getElementById(id);
  emitter.dispatchEvent(event);
};

export const scrollPage = (number, behavior) => {
  const allCanvasElements = document.getElementsByClassName("react-pdf__Page");
  const canvasArray = Array.from(allCanvasElements);
  const targetCanvas = canvasArray.find(
    (canvas) => canvas.getAttribute("data-page-number") === `${number}`
  );
  if (targetCanvas) {
    targetCanvas.scrollIntoView({ behavior: behavior });
  }
};

export const handleClearCookie = async () => {
  networkService("users/sign_out", "delete")
    .then((response) => {
      localStorage.clear();
      window.location.href = "/";
    })
    .catch((error) => {
      console.error("Error during sign out:", error);
    });
};

const toHHMMSS = (time) => {
  var sec_num = parseInt(time, 10); 
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;
  hours < 1 ? (hours = "--") : hours;
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return (hours < 10 ? "0" + hours : hours) + ":" + minutes + ":" + seconds;
};

export const filterCommonPage = (pages) => {
  let isLandingPage = pages?.findIndex(
    (item) => item?.page == item?.landing_page
  );
  var filteredPages = [];
  for (let i = 0; i < pages.length; i++) {
    if (pages.length > i + 1) {
      if (pages[i].page === pages[i + 1].page) {
        pages[i] = {
          date: pages[i].date,
          date_wrt_time_zone: pages[i].date_wrt_time_zone,
          element_tags: pages[i].element_tags.concat(pages[i + 1].element_tags),
          elements_imp_clicks: pages[i].elements_imp_clicks.concat(
            pages[i + 1].elements_imp_clicks
          ),
          exit_page: pages[i].exit_page,
          exit_page_time: pages[i].exit_page_time,
          is_landing_page: i == isLandingPage,
          landing_page: pages[i].landing_page,
          language_editions: pages[i].language_editions.concat(
            pages[i + 1].language_editions
          ),
          min_viewed: toHHMMSS(pages[i].seconds + pages[i + 1].seconds),
          optin_done: pages[i].optin_done,
          optin_reject: pages[i].optin_reject,
          once_optin: pages[i].once_optin,
          other_clicks: pages[i].other_clicks.concat(pages[i + 1].other_clicks),
          page: pages[i].page,
          seconds: pages[i].seconds + pages[i + 1].seconds,
          session_pause_time: pages[i].session_pause_time,
          show_pause_time: pages[i].show_pause_time,
          time_tooltip: pages[i].time_tooltip,
          video_on_page: pages[i].video_on_page,
          viewed_at: pages[i].viewed_at,
        };
        filteredPages.push(pages[i]);
        i++;
      } else {
        filteredPages.push({
          ...pages[i],
          is_landing_page: i == isLandingPage,
        });
      }
    } else {
      filteredPages.push({
        ...pages[pages.length - 1],
        is_landing_page: i == isLandingPage,
      });
    }
  }
  if (filteredPages.length > 2) {
    if (
      filteredPages[2].optin_done &&
      filteredPages[2].page === filteredPages[2].landing_page &&
      filteredPages[2].seconds < 3
    ) {
      filteredPages.splice(2, 1);
    }
  }

  return filteredPages;
};

export const handleErrorImage = (element) => {
  element.target.src = noImage;
};

export const viewsPercentage = (score, total) =>
  ((score / total) * 100).toFixed(2);

export const imageBlurWidth = (
  position,
  max_Val,
  keep_within_page,
  keep_proportions,
  oldWidthVal
) => {
  if (position.width > max_Val.max_Width) {
    if (keep_within_page) {
      position.width = max_Val.max_Width;
    }
    if (keep_proportions) {
      position.height = keepProportions(
        position.width,
        position.height,
        oldWidthVal
      );
    }
  } else {
    if (keep_proportions) {
      position.height = keepProportions(
        position.width,
        position.height,
        oldWidthVal
      );
    }
  }
  return position;
};

export const imageBlurHeight = (
  position,
  max_Val,
  keep_proportions,
  keep_within_page,
  oldHeightVal
) => {
  if (position.height > max_Val.max_Height) {
    position.height = max_Val.max_Height;
    position.width = max_Val.max_Width;
  } else {
    if (keep_proportions) {
      var prop_width = keepProportions(
        position.height,
        position.width,
        oldHeightVal
      );
      if (keep_within_page) {
        position.width =
          prop_width >= max_Val.max_Width ? max_Val.max_Width : prop_width;
      } else {
        position.width = prop_width;
      }
    }
  }
  return position;
};

export const textBlurWidth = function (
  position,
  max_Val,
  keep_proportions,
  oldWidthVal
) {
  if (position.width > max_Val.max_Width) {
    position.width = max_Val.max_Width;
    if (keep_proportions) {
      position.height = keepProportions(
        position.width,
        position.height,
        oldWidthVal
      );
    }
  } else {
    if (keep_proportions) {
      position.height = keepProportions(
        position.width,
        position.height,
        oldWidthVal
      );
    }
  }
  return position;
};

export const textBlurHeight = function (
  position,
  max_Val,
  keep_proportions,
  oldHeightVal
) {
  if (position.height > max_Val.max_Height) {
    position.height = max_Val.max_Height;
    position.width = max_Val.max_Width;
  } else {
    if (keep_proportions) {
      if (position.width < max_Val.max_Width) {
        position.width = keepProportions(
          position.height,
          position.width,
          oldHeightVal
        );
      }
    }
  }
  return position;
};

export const iframeBlurWidth = function (
  position,
  max_Val,
  keep_proportions,
  oldWidthVal
) {
  if (position.width > max_Val.max_Width) {
    position.width = max_Val.max_Width;
    if (keep_proportions) {
      position.height = keepProportions(
        position.width,
        position.height,
        oldWidthVal
      );
    }
  } else {
    if (keep_proportions) {
      position.height = keepProportions(
        position.width,
        position.height,
        oldWidthVal
      );
    }
  }
};

export const iframeBlurHeight = function (
  position,
  max_Val,
  keep_proportions,
  oldHeightVal
) {
  if (position.height > max_Val.max_Height) {
    position.height = max_Val.max_Height;
    position.width = max_Val.max_Width;
  } else {
    if (keep_proportions) {
      if (position.width < max_Val.max_Width) {
        position.width = editor.keepProportions(
          position.height,
          position.width,
          oldHeightVal
        );
      }
    }
  }
};

export const normalizeDimensions = (val, currentScale, desiredScale) => {
  if (undefined === desiredScale) {
    desiredScale = window.objInit?.zoom_lvl || 1;
  }
  return Math.round(val * (desiredScale / currentScale));
};

// Precise normalization that preserves enough decimal places to avoid
// round-trip drift (screen→base→screen). Unlike normalizeDimensions which
// uses Math.round() to an integer, this keeps 4 decimal places so the
// reverse conversion (base * zoom → screen) lands on the original pixel.
export const roundTripSafeNormalize = (screenValue, currentZoom, desiredZoom = 1) => {
  const result = screenValue * (desiredZoom / currentZoom);
  return Math.round(result * 10000) / 10000;
};

export const getNormalizedDimensions = (
  geometry = {},
  zoom = 1,
  pageDimensions = {},
  element,
  canvas
) => {
  const page_w = pageDimensions.width || 800;
  const page_h = pageDimensions.height || 1000;

  const rendered_w = canvas?.offsetWidth || page_w;
  const rendered_h = canvas?.offsetHeight || page_h;

  const scaleX = typeof zoom === "object" ? zoom.value || 1 : zoom;
  const scaleY = scaleX;

  let top = Math.round((geometry.top ?? 0) * scaleY);
  let left = Math.round((geometry.left ?? 0) * scaleX);
  let height = Math.round((geometry.height ?? 0) * scaleY);
  let width = Math.round((geometry.width ?? 0) * scaleX);

  if (geometry.keep_within_page) {
    top = Math.max(0, Math.min(top, rendered_h - height));
    left = Math.max(0, Math.min(left, rendered_w - width));
  }

  const geo = {
    position: "absolute",
    top,
    left,
    width,
    height,
    fontSize: `${10 * scaleY}pt`,
    lineHeight: 1.3,
  };

  return {
    top,
    left,
    height,
    width,
    geo,
  };
};

export const getOffset = (element) => {
  if (!element) return { top: 0, left: 0 };
  const rect = element.getBoundingClientRect();
  return { top: rect.top + window.scrollY, left: rect.left + window.scrollX };
};

export const calculateRectPos = (x1, y1, x2, y2) => {
  const left = Math.min(x1, x2);
  const top = Math.min(y1, y2);
  const width = Math.abs(x1 - x2);
  const height = Math.abs(y1 - y2);
  return { left, top, width, height };
};

export const gifProportion = (maxWidth, maxHeight, gifWidth, gifHeight) => {
  if (gifWidth === 0 || gifHeight === 0) {
    return [0, 0];
  }

  var widthRatio = maxWidth / gifWidth;
  var heightRatio = maxHeight / gifHeight;
  let [finalWidth,finalHeight]= fitImageIntoDrawnBox(maxWidth,maxHeight,gifWidth,gifHeight)

  // Pick the larger ratio to ensure one side fills its max
  var scale = Math.max(widthRatio, heightRatio);

  var newWidth = Math.round(gifWidth * scale);
  var newHeight = Math.round(gifHeight * scale);

  // return [newWidth, newHeight];
  return [finalWidth,finalHeight]
};

export const gifProportionCover = (maxWidth, maxHeight, gifWidth, gifHeight) => {
  if (gifWidth === 0 || gifHeight === 0) return [0, 0];

  const widthRatio = maxWidth / gifWidth;
  const heightRatio = maxHeight / gifHeight;

  const scale = Math.max(widthRatio, heightRatio); // fill box

  const newWidth = Math.round(gifWidth * scale);
  const newHeight = Math.round(gifHeight * scale);

  return [newWidth, newHeight];
};


export const constProportionRespectUserDrawnBox = (drawnWidth, drawnHeight, imageWidth, imageHeight) => {
  if (!imageWidth || !imageHeight) return [0, 0];

  const imageAspect = imageWidth / imageHeight;
  let finalWidth, finalHeight;

  if (drawnWidth >= drawnHeight) {
    finalWidth  = drawnWidth;
    finalHeight = Math.round(drawnWidth / imageAspect);
  } else {
    finalHeight = drawnHeight;
    finalWidth  = Math.round(drawnHeight * imageAspect);
  }

  return [finalWidth, finalHeight];
};

export const applyProportionalResize = (changedKey, newValue, originalWidth, originalHeight) => {
  if (!originalWidth || !originalHeight || !newValue) return [originalWidth, originalHeight];

  const aspectRatio = originalWidth / originalHeight;

  if (changedKey === "width") {
    const width = newValue;
    const height = Math.round(width / aspectRatio);
    return [width, height];
  } else {
    const height = newValue;
    const width = Math.round(height * aspectRatio);
    return [width, height];
  }
};

export const fitImageIntoDrawnBox = (drawnWidth, drawnHeight, imageWidth, imageHeight) => {
  if (!imageWidth || !imageHeight || !drawnWidth || !drawnHeight) return [0, 0];

  const imageAspect = imageWidth / imageHeight;
  const imageOrientation = imageWidth >= imageHeight ? "horizontal" : "vertical";
  const boxOrientation = drawnWidth >= drawnHeight ? "horizontal" : "vertical";

  let finalWidth, finalHeight;

  if (imageOrientation === boxOrientation) {
    // --- Same orientation ---
    if (imageOrientation === "horizontal") {
      // Match box width and adjust height
      finalWidth = drawnWidth;
      finalHeight = Math.round(drawnWidth / imageAspect);
    } else {
      // Vertical → match box height and adjust width
      finalHeight = drawnHeight;
      finalWidth = Math.round(drawnHeight * imageAspect);
    }
  } else {
    // --- Different orientation → contain logic ---
    const boxAspect = drawnWidth / drawnHeight;
    if (imageAspect > boxAspect) {
      finalWidth = drawnWidth;
      finalHeight = Math.round(drawnWidth / imageAspect);
    } else {
      finalHeight = drawnHeight;
      finalWidth = Math.round(drawnHeight * imageAspect);
    }
  }

  return [finalWidth, finalHeight];
};



          